/**
 * La geometría de las ventanas acopladas — un solo lugar para todas.
 *
 * POR QUÉ ESTOS NÚMEROS VIVEN ACÁ Y NO EN CADA VENTANA. Ya hay dos cosas que se acoplan abajo a la
 * derecha (el chat de WhatsApp y la prueba del agente) y van a haber más. Si cada una elige su ancho
 * y su margen, terminan desalineadas entre sí y peleando con lo que ya ocupa ese rincón. Es el mismo
 * problema que resolvió `AppIconButton` con los íconos: no es el tamaño, es que cada lugar elija el
 * suyo.
 *
 * 🪤 EL RINCÓN DE ABAJO A LA DERECHA YA ESTÁ OCUPADO. Ahí viven el FAB del copiloto, el del marcador
 * y la tarjeta de llamada activa. Por eso `DERECHA` no es 0: las ventanas arrancan más a la izquierda
 * y crecen hacia ese lado, así no tapan ninguno.
 *
 * 🪤 EL ALTO SE MIDE CONTRA LA PANTALLA, NO EN PÍXELES FIJOS. Una ventana que llega casi de borde a
 * borde es un modal con otra forma, y lo que se buscaba era exactamente lo contrario: acompañar el
 * trabajo sin reemplazarlo.
 */

/** Ancho de una ventana acoplada. */
export const ANCHO_ACOPLADA = 340;

/** Alto máximo: alto pero nunca de borde a borde. */
export const ALTO_ACOPLADA = 'min(560px, calc(100vh - 160px))';

/** Separación entre ventanas cuando hay más de una. */
export const GAP_ACOPLADA = 12;

/** Distancia al borde derecho — deja libre el rincón de los botones flotantes. */
export const DERECHA_ACOPLADA = 92;

/** Distancia al borde inferior. */
export const ABAJO_ACOPLADA = 20;

/** El verde de la cabecera del chat, para que las ventanas se reconozcan como de la misma familia. */
export const VERDE_ACOPLADA = '#075E54';
